// src/components/Navbar.js
import React from 'react';
import { Link } from 'react-router-dom';

const Navbar = ({ onLogout, ruolo, utente }) => {
  const linkStyle = {
    textDecoration: 'none',
    color: '#111',
    fontWeight: 500,
  };

  return (
    <nav
      style={{
        marginBottom: '20px',
        display: 'flex',
        gap: '15px',
        alignItems: 'center',
        background: '#f4f4f4',
        padding: '10px 20px',
        borderRadius: '10px',
      }}
    >
      {utente?.nome && <span style={{ fontWeight: 'bold' }}>👤 {utente.nome}</span>}

      {ruolo === 'admin' && (
        <>
          <Link to="/" style={linkStyle}>
            📊 Admin
          </Link>
          <Link to="/archivio" style={linkStyle}>
            🗂️ Archivio
          </Link>
          <Link to="/totali-ore" style={linkStyle}>
            📆 Totali Mensili
          </Link>
          <Link to="/gestione-presenze" style={linkStyle}>
            🕒 Gestione Presenze
          </Link>
          <Link to="/sedi" style={linkStyle}>
            🏢 Sedi
          </Link>
          <Link to="/utenti" style={linkStyle}>
            👥 Gestione Utenti
          </Link>
        </>
      )}

      {ruolo === 'responsabile' && (
        <>
          <Link to="/" style={linkStyle}>
            🔑 Accessi
          </Link>
          <Link to="/gestione-presenze" style={linkStyle}>
            🕒 Gestione Presenze
          </Link>
          <Link to="/utenti" style={linkStyle}>
            👥 Gestione Utenti
          </Link>
        </>
      )}

      {ruolo !== 'admin' && ruolo !== 'responsabile' && (
        <Link to="/" style={linkStyle}>
          🔑 Accessi
        </Link>
      )}

      <button onClick={onLogout} style={{ marginLeft: 'auto' }}>
        🔓 Logout
      </button>
    </nav>
  );
};

export default Navbar;
